<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-smart-tag-dashboard-table-page-detail-metrics">
    <table class="metrics-table" border="0" cellspacing="0" cellpadding="0">
    <tr>
      <td v-if="showSection('totalVolumeDMValue')" v-bind:class="isSelectedChart('totalVolume')" @click="handleSelectChart('totalVolume')" data-testid="AiTags-AiGeneratedTags-TagDetail-MetricsTab-TotalVolume">
        <div class="title">{{getTitle('totalVolume')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{formatNumber(topicData.totalVolumeDMValue, 0)}}</div>
          <div v-if="topicData.volumeChangePercent && topicData.volumeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.volumeChangeWithoutAbs>0,  down: topicData.volumeChangeWithoutAbs<0}">{{formaterNumber(topicData.volumeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.volumeChangePercent && topicData.volumeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.volumeChangePercent">
           <span v-if="topicData.volumeChangeWithoutAbs<0">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
           <span v-else-if="topicData.volumeChangeWithoutAbs>0">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
           <span v-else class="no-data">compared to {{formatNumber(topicData.totalVolumeCompareDMValue, 0)}} over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
        <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>

      <td v-if="showSection('avgAgentHandleTimeDisplay')"  v-bind:class="isSelectedChart('avgAgentHandleTime')" @click="handleSelectChart('avgAgentHandleTime')" data-testid="AiTags-AiGeneratedTags-TagDetail-MetricsTab-AvgAgentHandleTime">
        <div class="title">{{getTitle('avgAgentHandleTime')}}</div>
        <div class="value" v-bind:class="{multiLines:showingTwoLine, hidden: showingTwoLineHidden}">
          <div class="total">{{topicData.avgAgentHandleTimeDisplay}}</div>
          <div v-if="topicData.avgAgentHandleTimeChangePercent && topicData.avgAgentHandleTimeChangeWithoutAbs!=0" v-bind:class="{change: true, up: topicData.avgAgentHandleTimeChangeWithoutAbs>0,  down: topicData.avgAgentHandleTimeChangeWithoutAbs<0}">{{formaterNumber(topicData.avgAgentHandleTimeChangePercent)}}%<span class="icon"></span></div>
          <div v-else-if="topicData.avgAgentHandleTimeChangePercent && topicData.avgAgentHandleTimeChangeWithoutAbs==0" class="change">No Change</div>
          <div v-else class="change">N/A</div>
        </div>
        <div class="compare" v-if="topicData.avgAgentHandleTimeChangePercent">
          <span v-if="topicData.avgAgentHandleTimeChangeWithoutAbs<0">compared to {{topicData.avgAgentHandleTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else-if="topicData.avgAgentHandleTimeChangeWithoutAbs>0">compared to {{topicData.avgAgentHandleTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
          <span v-else class="no-data">compared to {{topicData.avgAgentHandleTimeCompareDisplay}} over the previous {{topicData.numOfDaysInRange}} days</span>
        </div>
        <div class="compare" v-else>
          <span class="no-data">Correct comparison not available for this time period</span>
        </div>
      </td>
    </tr>
    </table>
    
    <div ref="detailMetricsCharts" class="charts">
      <div class="toolbar">
        <el-button class="viewCharts" type="primary" data-testid="AiTags-AiGeneratedTags-TagDetail-MetricsTab-ViewCharts" @click="handleViewCharts">{{viewALLCharts ? "Collapse all trends" : "Show all trends"}}</el-button>
      </div>
      <div class="chart totalVolumeChart" v-if="(viewALLCharts || selectedChart=='totalVolume') && showChart">
        <detailMetricsChart :parent="module" ref="totalVolume" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="totalVolume" title="Volume" column="sumVolumeDMValue" :data="topicData" format="0,0" suffix="" :parentLoading='loading' />
      </div>
      <div class="chart avgAgentHandleTime" v-if="(viewALLCharts || selectedChart=='avgAgentHandleTime') && showChart">
        <detailMetricsChart :parent="module" ref="avgAgentHandleTime" :activeTab="activeTab" :selectedChart="selectedChart" :viewType="viewType" id="avgAgentHandleTime" title="Average Call Handle Time" column="sumHandlingTime" :data="topicData" format="time" suffix="m" :parentLoading='loading' />
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import WyUtils from '../../library/wy-utils.js';
import detailMetricsChart from './wy-smart-tag-dashboard-table-metrics-chart';

export default Vue.extend({
  name: 'wy-smart-tag-dashboard-table-page-detail-metrics',
  props: ['parent', 'activeTab'],

  components: {
    'detailMetricsChart': detailMetricsChart,
  },
  
  data() {
    return {
      module: this,
      loading: false,
      initDate: null,
      topicData: {},
      selectedChart: 'totalVolume',
      viewALLCharts: false,
      showingTwoLine: false,
      showingTwoLineHidden: false,
      preWindowWidth:0,
      showChart: true,

      titles: {
        'totalVolume': 'Volume',
        'avgAgentHandleTime': 'Average Call Handle Time',
        'avgAgentResponseTime': 'Average Agent Response Time',
      },

      viewType: null,
      fetchData: true
    }
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel', 'isHideResponse'])
  },

  methods: {
    ...mapActions(['fetchSmartTagTrend']),

    handleViewTypeChange(viewType) {
      this.viewType = viewType;
    },

    getTitle(key) {
      return this.titles[key];
    },

    showSection(sectionName) {
      let isShow = true;
      if(this.dataModel.columns) {
        let isExist = false;
        this.dataModel.columns.forEach(column => {
          if(column.name == sectionName) {
            isExist = true;
            if(column.hide){
              isShow = false;
            }
          }
        });
        if(!isExist) {
          isShow = false;
        }
      }
      this.dataModel.columns.forEach(column => {
        if(column.name == sectionName) {
          if(column.hide){
            isShow = false;
          }
        }
      });
      return isShow;
    },

    startLoading() {
      this.loadData();
      this.initDate = new Date();
      this.resizeWindowHandler();
      if(!this.loading) {
        this.logEventLoaded();
      }
    },

    logEventLoaded() {
      if(this.initDate) {
        this.initDate = null;
      }
    },

    formatNumber(val, dec=2) {
      return val!=null ? WyUtils.formatterNumber(val.toFixed(dec)) : 0;
    },

    formaterNumber(value) {
      let formatValue = '';
      if(typeof value == "number") {
        formatValue = WyUtils.formatterFloatNumber(value);
      }
      else {
        formatValue = WyUtils.formatterFloatNumber(parseFloat(value));
      }
      return formatValue;
    },

    isSelectedChart(chart) {
      return {
        selected: this.selectedChart==chart,
        showAllChart: this.viewALLCharts,
      };
    },

    handleSelectChart(key) {
      this.selectedChart = key;
      this.viewALLCharts = false;
    },

    handleViewCharts() {
      this.viewALLCharts = !this.viewALLCharts;
      this.showChart = false;
      setTimeout(()=>{
        this.showChart = true;
      },300)
    },

    async loadData() {
      if(this.fetchData) {
        this.loading = true;
        this.topicData = this.parent.currentItem;
        let result = await this.fetchSmartTagTrend({item: this.parent.currentItem});
        if(result.data && result.data.length > 0) {
          this.topicData.trend = result.data;
          this.topicData.trend.forEach(item => {
            item.sumVolumeDMValue = (item.sumVolume!=null ? item.sumVolume * this.$store.getters.xnumber: item.sumVolume);
          })
        }
        this.loading = false; 

        if(this.$refs.totalVolume) this.$refs.totalVolume.changeDateRange(this.viewType);
        if(this.$refs.avgAgentHandleTime) this.$refs.avgAgentHandleTime.changeDateRange(this.viewType);
        if(this.$refs.avgAgentResponseTime) this.$refs.avgAgentResponseTime.changeDateRange(this.viewType);
        
        this.parent.stopLoadingByTab('metrics');
        this.logEventLoaded();
        this.fetchData = false;
      }
    },

    resizeWindowHandler() {
      if(Math.abs(this.preWindowWidth - window.innerWidth) > 5) {
        this.showingTwoLineHidden = true;
        this.showingTwoLine = false;
        setTimeout(()=>{
          let tds = document.querySelectorAll('.metrics-table tr > td > div:nth-child(2) > div:nth-child(2)');
          if(tds){
            let isTwoLines = false;
            tds.forEach((td) => {
              if(td.offsetTop > 62) {
                isTwoLines = true;
              }
            })
            if(isTwoLines) {
              this.showingTwoLine = true;
            }
            else {
              this.showingTwoLine = false;
            }
          }
          this.showingTwoLineHidden = false;
        },0)
        this.preWindowWidth = window.innerWidth;
      }
    }
  },

  created() {
    window.addEventListener("resize", this.resizeWindowHandler);
    this.initDate = new Date();
    this.loadData();
  },

  destroyed() {
    window.removeEventListener("resize", this.resizeWindowHandler);
  },

  mounted() {
    document.querySelector('.wy-smart-tag-dashboard-table-page-detail-metrics').addEventListener('scroll', ()=>{
      if(document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown')) {
        document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown').remove()
      }
    })

    this.$refs.detailMetricsCharts.addEventListener('scroll', ()=>{
      if(document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown')) {
        document.querySelector('.el-select-dropdown.el-popper.line-chart-dropdown').remove()
      }
    })
    
    this.preWindowWidth = window.innerWidth;
    if(document.querySelectorAll('.metrics-table tr > td') )
      document.querySelectorAll('.metrics-table tr > td').forEach((tds) => {
      let valueDiv = tds.querySelectorAll('div')[1].querySelectorAll('div')[1];
      if(valueDiv.offsetTop > 62) {
        this.showingTwoLine = true;
      }
    })
  }
});
</script>

<style lang="scss">
.wy-smart-tag-dashboard-table-page-detail-metrics {
  .metrics-table {
    width: 100%;

    > tr > td {
      box-sizing: border-box;
      border-right: 1px solid #e8e8e8;
      border-bottom: 1px solid #e8e8e8;
      height: 150px;
      padding: 20px 20px 20px 20px;
      vertical-align: top;
      color: #002852;
      cursor: pointer;

      .title {
        height: 35px;
        font-size: 15px;
      }
      .value.multiLines > .total {
        display: block;
      }
      .value.multiLines > .change {
        margin-left: 1px;
      }
      .value.hidden > .change{
        visibility: hidden;
      }
      .value {
        font-weight: bold;
        font-size: 24px;
        margin-bottom: 10px;

        div {
          display: inline-block;
        }
        .el-no-data {
          cursor: pointer;
          background-image: url('../../assets/icons/icon_comparison_data_not_available.svg') !important;
          background-size: 24%;
          background-repeat: no-repeat;
          background-position-y: 5px;
          background-position-x: 4px;
          background-color: transparent !important;
          border: 0px;
          margin-left: 8px;
          padding-left: 20px;
        }
        .el-no-data:hover {
          background-color: unset;
        }
        .change {
          font-size: 16px;
          margin-left: 12px;
        }
      }

      .change.up {
        color: #4448A2;
        .icon {
          background-image: url("../../assets/icons/icon_arrow_up.svg");
          color: #4448A2;
          background-size: 100%;
          background-position-x: 1px;
          background-position-y: 3px;
          background-repeat: no-repeat;
          height: 16px;
          width: 16px;
          display: inline-block
        }
      }
      .change.down {
        color: #3E6891;
        .icon {
          background-image: url("../../assets/icons/icon_arrow_down.svg");
          color: #8060A5;
          background-size: 100%;
          background-position-x: 1px;
          background-position-y: 3px;
          background-repeat: no-repeat;
          height: 16px;
          width: 16px;
          display: inline-block;
        }
      }

      .compare {
        font-size: 14px;
        
        .no-data {
          color: #002852;
          // font-weight: 500;
        }
      }
    }

    > tr > td.selected {
      border-bottom: 3px solid #214586;
      .title {
        color: #214586;
        font-weight: bold;
      }
      .value {
        color: #214586;
      }
    }

    > tr > td.showAllChart {
      border-bottom: 3px solid #214586;
      .title {
        color: #214586;
        font-weight: bold;
      }
      .value {
        color: #214586;
      }
    }

    > tr > td:last-child {
      border-right: none;
    }
  }

  .charts {
    padding: 20px 30px 0px 30px;
    // height: calc(100vh - 495px);
    overflow-y: hidden;
        
    .toolbar {
      margin-bottom: 10px;
      text-align: right;

      .viewCharts.el-button--primary {
        background-color: #214586;
        border-color: #214586 !important;
        box-shadow: 1px 1px 6px #0033664D;
        border-radius: 14px;
        padding: 7px;      
        width: 150px;
      }
    }
    div.chart {
      // margin-bottom: 26px;      
      //box-shadow: 5px 5px 6px #00000029;
      //border-radius: 25px;
    }
  }
  
}
</style>